import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink,CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
 isMainDropdownOpen: boolean = false;
 isSubDropdownOpen: boolean = false;


  toggleMainDropdown() {
  this.isMainDropdownOpen = !this.isMainDropdownOpen;
}

openSubDropdown() {
  this.isSubDropdownOpen = true;
}
}
